import IconCheckedSuccess from "../../components/atoms/IconCheckedSuccess"
import { initPdiComponent } from "../../core/service/BusinessLogicService"
import { getOrderStorageDays } from "../../core/constants/orderStorage"
import { loc } from "../../core/utils"
import { withTunnelDataContext } from "../hoc/withTunnelDataContext"
import React, { useEffect } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"

const SimulationFinalPage = ({ tunnelData }) => {
  const simulationStorageTime = getOrderStorageDays(tunnelData.tenant)
  useEffect(() => {
    initPdiComponent("SimulationFinalPage")
  }, [])

  return (
    <Container fluid>
      <Row noGutters>
        <Col className="misc-block">
          <Row>
            <Col sm={12}>
              <Container>
                <Row className="justify-content-center">
                  <Col xs={11} sm={10} md={10} lg={6} className="hard-shadow-white-block text-center misc-mono-block">
                    <IconCheckedSuccess />
                    <h1>{loc("simulation_final_page_title")}</h1>
                    {simulationStorageTime ? (
                      <div>
                        {loc("simulation_final_page_content", {
                          simulationStorageTime
                        })}
                      </div>
                    ) : (
                      <div>{loc("simulation_final_page_content", { simulationStorageTime: 10 })}</div>
                    )}
                    <Button href={`${tunnelData?.pdiRetailUrl}login?tenant=${tunnelData.tenant}`}>{loc("Back")}</Button>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default withTunnelDataContext(SimulationFinalPage)
